const Config = {
    environment: 'staging',
    baseURL:'https://api.aanands.com/v1'
}

export default Config